import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('AppNotification'),(!_vm.isNoAuthRoute)?_c('IdleLogout'):_vm._e(),(_vm.isAuthenticated && !_vm.isNoAuthRoute && !_vm.isPrintPage)?_c('Header'):_vm._e(),_c('router-view',{key:_vm.$routeKey})],1)}
var staticRenderFns = []

export { render, staticRenderFns }